import { selectChoosenSearchTag } from '../selectors';
import { fetchedInstantResults } from '../actions';
import { SearchResponse } from '../types';
import { Thunk } from '../../../../types.global';
import { createDebouncedAction } from '../../../../store/utils';

const fetcherInstantResults = (q: string): Thunk => async (dispatch, getState) => {
  const state = getState();
  const choosenSearchTag = selectChoosenSearchTag(state);

  if (state.search.isSubmitted || !state.search.provided) {
    dispatch(fetchedInstantResults.fulfilled(null));
    return;
  }

  const parsedQ = (() => {
    try {
      if (choosenSearchTag?.u) {
        const url = new URL(choosenSearchTag.u);
        return `site:${url.hostname} ${q}`;
      }
    } catch (err) {
      console.error('parsedQ', err);
    }

    return q;
  })();

  const query = new URLSearchParams({ q: parsedQ, utm_medium: 'Extension' });

  try {
    const res = await fetch(`${process.env.APP_URL}/api/web?${query}`);

    if (res.status !== 200) {
      const err = await res.text();
      console.error(`fetcherInstantResults:${res.status}`, err);
      dispatch(fetchedInstantResults.rejected(q));
      return;
    }

    const result = (await res.json()) as SearchResponse;
    dispatch(fetchedInstantResults.fulfilled(result));
  } catch (err) {
    console.error(`fetcherInstantResults:500`, err);
    dispatch(fetchedInstantResults.rejected(q));
  }
};

const debouncedFetch = createDebouncedAction(fetcherInstantResults, 500);

export const fetchInstantResults = (q: string, skipDebounce = false): Thunk => async (dispatch) => {
  dispatch(fetchedInstantResults.pending(q));

  if (skipDebounce) debouncedFetch.cancel();
  dispatch(skipDebounce ? fetcherInstantResults(q) : debouncedFetch(q));
};
